export default __webpack_public_path__ + "static/media/fundingSourcesWallet.57dd1ecb.png";